<template>
  <el-form
    :model="form"
    ref="form"
    status-icon
    label-position="top"
    label-width="110px"
    size="medium"
    class="form"
  >
    <el-form-item label="">
      <el-checkbox v-model="form.cliente">Cliente</el-checkbox>
      <el-checkbox v-model="form.vendedor">Vendedor</el-checkbox>
      <el-checkbox v-model="form.proveedor">Proveedor</el-checkbox>
    </el-form-item>
    <el-form-item
      label="Documento/Nit"
      prop="documento"
      :rules="[{ required: true, message: 'Campo Obligatorio' }]"
    >
      <el-input
        type="text"
        v-model="form.documento"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="Nombre"
      prop="nombre"
      :rules="[{ required: true, message: 'Campo Obligatorio' }]"
    >
      <el-input
        type="text"
        v-model="form.nombre"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="Dirección"
      prop="direccion"
      :rules="[{ required: true, message: 'Campo Obligatorio' }]"
    >
      <el-input
        type="text"
        v-model="form.direccion"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="Ciudad"
      prop="ciudad"
      :rules="[{ required: true, message: 'Campo Obligatorio' }]"
    >
      <el-input
        type="text"
        v-model="form.ciudad"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="Email"
      prop="email"
      :rules="[{ required: true, message: 'Campo Obligatorio' }]"
    >
      <el-input
        type="text"
        v-model="form.email"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item label="Teléfono" prop="telefono">
      <el-input
        type="text"
        v-model="form.telefono"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item v-if="form.cliente" label="Nacimiento" prop="nacimiento">
      <el-date-picker
        v-model="form.nacimiento"
        type="date"
        format="yyyy/MM/dd"
        value-format="yyyy-MM-dd"
        placeholder="Selecciona"
      >
      </el-date-picker>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapMutations,  mapActions } from 'vuex'
import { store, update, edit } from "@/api/person";
export default {
  data() {
    return {
      loading: false,
      form: {
        documento: "",
        nombre: "",
        direccion: "",
        ciudad: "",
        email: "",
        telefono: "",
        nacimiento: "",
        cliente: null,
        vendedor: null,
        proveedor: null,
      }
    };
  },
  props:['payload'],
  created(){
    let me = this
    if(me.payload.field_id)
      me.editThrid(me.payload.field_id)
    
    bus.$on("save", function (payload) {
      me.submitForm();
    });
    bus.$on("update", function (payload) {
      me.submitForm();
    });
    bus.$on("cancel", function (payload) {
      me.resetForm();
      bus.$emit("close");
    });
  },
  methods: {
    ...mapMutations(['SET_RESPONSE','setRightMenuDrawer']),
    ...mapActions('third',['getAllAction']),
    ...mapActions(['showErrors']),
    submitForm() {
      try {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.payload.edit) {
              this.updateForm();
            } else {
              this.saveForm();
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    async saveForm() {
      try {
        let { data } = await store(this.form)
        if (data.code === 200) {
          this.SET_RESPONSE({type: 'success', msg: 'Tercero guardado.'})
          this.setRightMenuDrawer(false)
          this.getAllAction();
        } else {
          this.SET_RESPONSE({type: 'error', msg: 'Error al guardar.'})
        }
      } catch (error) {
        if (error.response.status == 422)
          this.showErrors(error.response.data.errors)
      }
    },
    async updateForm() {
      try {
        let { data } = await update(this.form)
        if (data.code === 200) {
          this.SET_RESPONSE({type: 'success', msg: 'Tercero actualizado.'})
          this.setRightMenuDrawer(false)
          this.getAllAction();
        } else {
          this.SET_RESPONSE({type: 'error', msg: 'Error al actualizar.'})
        }
      } catch (error) {
        if (error.response.status == 422)
          this.showErrors(error.response.data.errors)
      }
    },
    resetForm() {
      this.$refs['form'].resetFields();
      this.form.id = "";
      this.form.cliente = null;
      this.form.vendedor = null;
      this.form.proveedor = null;
    },
    async editThrid(id){
      try {
        this.editing = true
        let data = await edit(id)
        this.form = data.data
        if (data.data.cliente == '1') {
          this.form.cliente = true
        }
        if (data.data.vendedor == '1') {
          this.form.vendedor = true
        }
        if (data.data.proveedor == '1') {
          this.form.proveedor = true
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>